import {
  Box,
  Stack,
  IconButton,
  Typography,
  useTheme
} from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';

import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActivitySectionLayout } from 'modules/components/layer31';



export type ActivityHeaderSectionVerticalLayoutProps = {
  actionButtonsGroup: ReactNode;
  title: string;
  subTitle: string;
  children: ReactNode;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivityHeaderSectionVerticalLayoutProps) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (

    <Box
      flex='1 1 0'
    >
      <Box
        padding='1.25rem'
        borderRadius='1.5rem'
        border={`1px solid ${theme.palette.customGray.main}`}
      >
        <ActivitySectionLayout.FC>
          <Stack
            direction='row'
            overflow='clip'
            alignItems='flex-start'
            justifyContent='space-between'
            columnGap='1rem'
          >
            <Stack
              direction='row'
              columnGap='1rem'
              alignItems='stretch'
            >
              {/* BACK BUTTON */}
              <IconButton
                onClick={() => {
                  navigate(-1);
                }}
                sx={{
                  width: '2.25rem',
                  height: '2.25rem',
                  padding: '0.625rem',
                  borderRadius: '.5rem',
                  background: theme.palette.secondary.main
                }}
              >
                <CustomIcon.medium.FC
                  icon='CHEVRONLEFT'
                  stroke={theme.palette.secondary.darker}
                />
              </IconButton>
              <Stack
                direction='column'
                rowGap='.25rem'
              >
                {/* title */}
                <Typography
                  textOverflow='ellipsis'

                  variant='modalTitle'
                  sx={{
                    wordBreak: 'break-word'
                  }}
                >
                  {props.title}
                </Typography>
                {/* subTitle */}
                <Typography
                  textOverflow='ellipsis'
                  variant='formLabel'
                  sx={{
                    wordBreak: 'break-word'
                  }}
                >
                  {props.subTitle}
                </Typography>
              </Stack>
            </Stack>
            {/* ACTION BUTTON GROUP */}
            {props.actionButtonsGroup}
          </Stack>
          {props.children}



        </ActivitySectionLayout.FC>
      </Box>

    </Box>

  );
};
